setTimeout(() => {
  let estimator = document.querySelectorAll('.delivery-estimator');

  estimator.forEach((est) => {
    let string = est.innerHTML;
    string = string.replace('pá', '');
    string = string.replace('. ', '/');
    string = string.replace('. ', '/');
    string = string.replace('&nbsp;', '');

    est.innerHTML = `${string}`;
  });
}, 1000);

// opacity scroll start
function reveal() {
  let reveals = document.querySelectorAll('.zoom-image');

  for (let i = 0; i < reveals.length; i++) {

    if (window.innerWidth >= 768) {
      let windowHeight = window.innerHeight;
      let elementTop = reveals[i].getBoundingClientRect().top;
      let elementBottom = reveals[i].getBoundingClientRect().bottom;
      let elementVisible = windowHeight / 2 + 200;

      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.remove('is-opacity');
      } else {
        reveals[i].classList.add('is-opacity');
      }

      if (elementBottom > windowHeight - windowHeight / 2 + 100) {
        reveals[i].classList.remove('is-under');
      } else {
        reveals[i].classList.add('is-under');
      }
    } else {
      let windowHeight = window.innerHeight;
      let elementTop = reveals[i].getBoundingClientRect().top;
      let elementBottom = reveals[i].getBoundingClientRect().bottom;
      let elementVisible = windowHeight / 2 - 100;


      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.remove('is-opacity');
      } else {
        reveals[i].classList.add('is-opacity');
      }

    }
  }
}

window.addEventListener('scroll', reveal);


//sus faq page

let questionsFaqs = document.querySelectorAll('.faq__question');
let currentFaqs = '';
if (questionsFaqs) {
  let answers = document.querySelectorAll('.faq__answer');
  questionsFaqs.forEach((question, i) => {
    question.addEventListener('click', () => {
      if (currentFaqs === i) {
        if (question.parentElement.classList.contains('active')) {
          hideAll(answers);
          question.parentElement.classList.remove('active');
        } else {
          question.parentElement.classList.add('active');
          showText(question.nextElementSibling);
        }
      } else {
        questionsFaqs.forEach((question, g) => {
          question.parentElement.classList.remove('active');
        });
        hideAll(answers);
        question.parentElement.classList.toggle('active');
        showText(question.nextElementSibling);
      }
      currentFaqs = i;
    });

  });

  function hideAll(answers) {
    for (let i = 0; i < answers.length; i++) {
      answers[i].style.height = '0';
    }
  }

  function showText(question) {
    question.style.height = question.scrollHeight + 'px';
  }
}

//faq material

let questionsAcc = document.querySelectorAll('.accordion__title');
let questionsItemAcc = document.querySelectorAll('.accordion__item');

let documentUrl = document.location.hash;
documentUrl = documentUrl.replace('#', '');
if (documentUrl) {
  questionsItemAcc.forEach((question, i) => {
    if (documentUrl === question.id) {
      setTimeout(() => {
        let heightBar = document.querySelector('#announcement-bar-header').offsetHeight;
        let y = question.getBoundingClientRect().top + window.scrollY - heightBar;
        window.scroll({
          top: y,
          behavior: 'smooth',
        });
        question.classList.add('is-active');
        question.querySelector('.accordion__content-wrap').style.height = question.querySelector('.accordion__content-wrap').scrollHeight + 'px';

      }, 500);
    }
  });
}

let currentAcc = '';
if (questionsAcc) {
  let answers = document.querySelectorAll('.accordion__content-wrap');
  questionsAcc.forEach((question, i) => {
    question.addEventListener('click', () => {
      if (currentAcc === i) {
        if (question.parentElement.classList.contains('is-active')) {
          hideAll(answers);
          question.parentElement.classList.remove('is-active');
        } else {
          question.parentElement.classList.add('is-active');
          showText(question.nextElementSibling);
        }
      } else {
        questionsAcc.forEach((question, g) => {
          question.parentElement.classList.remove('is-active');
        });
        hideAll(answers);
        question.parentElement.classList.toggle('is-active');
        showText(question.nextElementSibling);
      }
      currentAcc = i;
    });

  });

  function hideAll(answers) {
    for (let i = 0; i < answers.length; i++) {
      answers[i].style.height = '0';
    }
  }

  function showText(question) {
    question.style.height = question.scrollHeight + 'px';
  }
}

// document.querySelectorAll('.first-level-menu.has-child').forEach((element) => {
//   element.addEventListener('mouseover', () => {
//     element.classList.add('hover');
//     document.getElementById('root').classList.add('over-hover-menu');
//   });
//   element.addEventListener('mouseout', () => {
//     element.classList.remove('hover');
//     document.getElementById('root').classList.remove('over-hover-menu');
//   });
// });

//Cart drawer

let anDrawer = document.querySelector('#announcement-bar-header');
let buttonProduct = document.querySelector('.product-form__submit');
let drawerHeight = document.querySelector('.drawer');

if (buttonProduct) {
  buttonProduct.addEventListener('click', function() {
    if (anDrawer.classList.contains('scroll-down')) {
      drawerHeight.classList.add('fullHeight');
    } else {
      drawerHeight.classList.remove('fullHeight');
    }
  });
}

// Header

let announcementBarHeader = document.getElementById('announcement-bar-header');

window.addEventListener('scroll', () => {
  // if (window.pageYOffset < 300) {
  //   announcementBarHeader.classList.add('show');
  //   announcementBarHeader.classList.remove('hide');
  // } else {
  //   announcementBarHeader.classList.add('hide');
  //   announcementBarHeader.classList.remove('show');
  // }
});
